import { auth } from "../firebase";

const API_BASE = process.env.REACT_APP_ACCOUNTING_API_BASE_URL || "http://localhost:4001/api/v1";

async function getToken() {
  const user = auth.currentUser;
  if (!user) throw new Error("Not authenticated");
  return user.getIdToken();
}

async function apiRequest(path, options = {}) {
  const token = await getToken();
    const headers = { "Content-Type": "application/json", ...(options.headers || {}) };
  if (token) headers.Authorization = 'Bearer ' + token;
  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `Request failed (${res.status})`);
  return data;
}

export async function lookupChNumberPublic(chNumber) {
  const res = await fetch(`${API_BASE}/visitor/ch-lookup/${encodeURIComponent(chNumber)}`);
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || "Company not found");
  return data;
}

export async function registerVisitor({ email, password, displayName, chNumber }) {
  const res = await fetch(`${API_BASE}/visitor/register`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password, displayName, chNumber }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || "Registration failed");
  return data;
}

export const getVisitorProfile = () => apiRequest("/visitor/me");
export const getVisitorCs01List = () => apiRequest("/visitor/cs01");
export const getVisitorCs01Fee = () => apiRequest("/visitor/cs01-fee");
export const createVisitorCs01 = (body) => apiRequest("/visitor/cs01", { method: "POST", body: JSON.stringify(body) });
export const createPaymentIntent = (csId) => apiRequest(`/visitor/cs01/${csId}/payment-intent`, { method: "POST" });
export const confirmVisitorPayment = (csId, body) => apiRequest(`/visitor/cs01/${csId}/confirm-payment`, { method: "POST", body: JSON.stringify(body) });
export const submitVisitorCs01 = (csId) => apiRequest(`/visitor/cs01/${csId}/submit`, { method: "POST" });

export async function getSuperAdminConfig() {
  return apiRequest("/admin/config");
}

export async function updateSuperAdminConfig(body) {
  return apiRequest("/admin/config", { method: "PUT", body: JSON.stringify(body) });
}




